import { restApiRP } from "@plannel/services/utils/rest-api";

const getChartData = params => {
  return restApiRP.get("/api/expired/inventory/chart", { params });
};

const getGridData = params => {
    return restApiRP.get("/api/expired/inventory", { params });
  };

const getAllForCSV = params => {
  return restApiRP.get("/api/expired/inventory/csv", { params });
};

const expiredInventoryService = {
    getChartData,
    getGridData,
    getAllForCSV,
};

export default expiredInventoryService;